import React, { useState, useEffect } from 'react'
import { useMasterChief, usePairContract } from '../../../hooks/useContract'
import { Link } from 'react-router-dom'
import styled from 'styled-components'
import DoubleCurrencyLogo from '../../../components/DoubleLogo'
import { useToken } from '../../../hooks/Tokens'
import Loader from '../../../components/Loader'
import { useActiveWeb3React } from '../../../hooks'
import { formatUnits } from 'ethers/lib/utils'
import { BigNumber } from 'ethers'
import { roundToDecimalPlace } from '../../../utils/data'
import { SkeletonText } from '../../../components/Skeleton'
import { Currency, WETH9 } from '@uniswap/sdk-core'
import { CURRENT_CHAIN } from '@hyperswap/addresses'
import { API_POOL_INDEXED_BASE_URL } from 'constants/links'
import axios from 'axios'
interface PoolProps {
  pool: any
  pId: number
}

const PoolCardStyled = styled(Link)`
  cursor: pointer;
  background: ${({ theme }) => theme.bg1}
  display: flex;
  flex-direction: column;
  border-radius: 16px;
  padding: 20px;
  width: 100%;
   transition: all 300ms;
  text-decoration: none;
  color: white;
  min-height: 184px;

  &:hover {
    background: ${({ theme }) => theme.bg2}
  }
`

const EntriesStyled = styled.div`
  display: grid;
  grid-template-columns: 1.2fr 1fr;
  row-gap: 0.75rem;
  margin-top: 8px;
`

const PoolCard: React.FC<PoolProps> = ({ pool, pId }) => {
  const { chainId, account, active } = useActiveWeb3React()
  const masterChiefContract = useMasterChief()

  const PairContract = usePairContract(pool.lpToken)
  const [token0, setToken0] = useState('')
  const [token1, setToken1] = useState('')
  const token0Currency = useToken(token0)
  const token1Currency = useToken(token1)
  const [user, setUser] = React.useState<any>()
  const [apr, setApr] = React.useState<string | null>(null)

  const againstWETHCurrency = token1Currency?.address === WETH9[CURRENT_CHAIN].address ? token0Currency : token1Currency

  const staked = user?.amount
  const stakedFormatted = formatUnits(staked ? staked : BigNumber.from(0), 18)

  useEffect(() => {
    const fetchUserInfo = async () => {
      if (
        chainId &&
        pId > -1 &&
        account &&
        active &&
        masterChiefContract &&
        token0Currency &&
        token1Currency &&
        againstWETHCurrency
      ) {
        try {
          const userInfo = await masterChiefContract.userInfo(pId, account)
          const apr = await axios.get(`${API_POOL_INDEXED_BASE_URL}/api/apr?token1=${againstWETHCurrency.address}`)

          if (apr.data.success === true) {
            setApr(apr.data.data.apr)
          }
          setUser(userInfo)
        } catch (error) {
          console.error('Error fetching user info:', error)
        }
      }
    }
    fetchUserInfo()
  }, [account, pId, masterChiefContract, token0Currency, token1Currency, chainId, active, pool, againstWETHCurrency])

  useEffect(() => {
    const fetchTokens = async () => {
      if (PairContract) {
        try {
          const token0Address = await PairContract.token0()
          const token1Address = await PairContract.token1()

          setToken0(token0Address)
          setToken1(token1Address)
        } catch (error) {
          console.error('Error fetching token addresses:', error)
        }
      }
    }

    fetchTokens()
  }, [PairContract])

  const totalDeposit = pool?.totalDeposit
  const totalDepositFormatted = formatUnits(totalDeposit ? totalDeposit : BigNumber.from(0), 18)

  /* const allocPoints = pool?.allocPoint ? pool?.allocPoint : BigNumber.from(0)
  const allocPointsIsZero = allocPoints.isZero() */

  return (
    <PoolCardStyled role="button" to={`/farm/${pool.lpToken}`}>
      {token0Currency && token1Currency ? (
        <>
          <div style={{ display: 'flex', alignItems: 'center', gap: '6px', fontSize: '14px' }}>
            <DoubleCurrencyLogo
              currency0={token0Currency as Currency}
              currency1={token1Currency as Currency}
              size={30}
              margin={true}
            />
            <h2 style={{ fontSize: '14px' }}>{`${token0Currency.symbol}-${token1Currency.symbol}`}</h2>
          </div>
          <EntriesStyled>
            <span style={{ fontWeight: 500, fontSize: '14px' }}>Liquidity</span>
            <span style={{ fontWeight: 500, fontSize: '14px' }}>Pool APR</span>
            <span style={{ fontSize: '12px' }}>{roundToDecimalPlace(totalDepositFormatted, '2')} HSPX-LP</span>
            <span style={{ fontSize: '12px' }}>{apr ? `${apr}%` : <SkeletonText width="30%" height="100%" />}</span>
          </EntriesStyled>
          <EntriesStyled>
            <span style={{ fontWeight: 500, fontSize: '14px' }}>Farm APR</span>
            <span style={{ fontWeight: 500, fontSize: '14px' }}>Your Stake</span>
            <SkeletonText width="30%" height="100%" />
            <span style={{ fontSize: '12px' }}>{roundToDecimalPlace(stakedFormatted, '2')} HSPX-LP</span>
          </EntriesStyled>
        </>
      ) : (
        <div style={{ margin: 'auto' }}>
          <Loader size="24px" />
        </div>
      )}
    </PoolCardStyled>
  )
}
export default PoolCard
